// SPDX-License-Identifier: AGPL-3.0-or-later

import { useState } from 'react';
import { Link, useParams } from 'react-router';
import { Renderer, type DraftAnswers } from '@intakeform/ui';
import { useQuestionnaire } from '../../api/questionnaires.js';

export function PreviewRoute() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useQuestionnaire(id);
  const [answers, setAnswers] = useState<DraftAnswers>({});

  if (isLoading) return <p className="muted">Loading…</p>;
  if (error || !data) return <div className="error-banner">Failed to load form.</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Preview · {data.resource.title ?? 'Untitled'}</h1>
        <Link
          to={`/builder/${id}`}
          style={{ color: 'rgb(var(--palette-primary-700))', fontWeight: 500 }}
        >
          Back to builder
        </Link>
      </div>
      <p className="muted">
        Renders the form exactly as a patient sees it. Answers entered here are not submitted.
      </p>
      <Renderer
        questionnaire={data.resource}
        answers={answers}
        onChange={(linkId, value) => setAnswers((a) => ({ ...a, [linkId]: value }))}
      />
    </div>
  );
}
